import { useState } from "react";

/**
 * useFormInputs hook, as adapted from: https://medium.com/@geeky_writer_/using-react-hooks-to-create-awesome-forms-6f846a4ce57
 *
 * @param {object} initialInputState the initial values of the form inputs
 * @param {function} callback function to call when form is submitted
 */
const useFormInputs = (initialInputState = {}, callback) => {
  const [inputs, setInputs] = useState(initialInputState);
  const handleSubmit = event => {
    if (event) {
      event.preventDefault();
    }
    callback();
  };
  const handleInputChange = event => {
    event.persist();
    setInputs(inputs => ({
      ...inputs,
      [event.target.name]: event.target.value
    }));
  };

  return {
    handleSubmit,
    handleInputChange,
    inputs
  };
};

export default useFormInputs;
